import { render, staticRenderFns } from "./SuNingDetail.vue?vue&type=template&id=11487ce8&"
import script from "./SuNingDetail.vue?vue&type=script&lang=js&"
export * from "./SuNingDetail.vue?vue&type=script&lang=js&"
import style0 from "./SuNingDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports